import { render, staticRenderFns } from "./DrawerContent.vue?vue&type=template&id=4324d0a2&"
import script from "./DrawerContent.vue?vue&type=script&lang=js&"
export * from "./DrawerContent.vue?vue&type=script&lang=js&"
import style0 from "./DrawerContent.vue?vue&type=style&index=0&id=4324d0a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports